// THIS UTIL IS DEPRECATED. USE APP-COMPONENT UTIL INSTEAD
import moment from 'moment';
function getAge(dateOfBirth) {
  var dob = moment.unix(dateOfBirth).utc();
  return moment().diff(dob, 'years');
}
export default getAge;